export default __webpack_public_path__ + "static/fv-black-text-pattern-af53abe657a85fd3fda6cc1372a5eac9.jpg";